import {useLogout} from '../../hooks/useLogout';

export function Logout() {
  const {logout} = useLogout();
  logout();

  return null;
}
